<template>
	<div>
		<div
			:class="[
				'display-none display-xl-block',
				{ 'padding-bottom-normal border-horizontal': horizontal },
				{ 'border-vertical': vertical }
			]"
		>
			<div v-if="horizontal">
				<span
					v-for="(item, index) in items"
					:key="item"
					:class="[
						'font-size-big margin-horizontal-normal margin-vertical-big padding-top-normal cursor-pointer',
						{ 'ink-lighter-1': active !== item },
						{ 'active-horizontal sb padding-bottom-normal': active === item }
					]"
					@click="$emit('onChange', item)"
					>{{ item }}<span v-if="counters"> ({{ counters[index] }})</span></span
				>
			</div>
			<div
				v-else
				v-for="item in items"
				:key="item"
				:class="[
					'font-size-big padding-left-big margin-bottom-big',
					{ 'ink-lighter-1': active !== item },
					{ 'active-vertical sb': active === item }
				]"
			>
				<span @click="$emit('onChange', item)" class="cursor-pointer"
					>{{ item }}<span v-if="counters"> ({{ counters[index] }})</span></span
				>
			</div>
		</div>

		<div class="display-block display-xl-none">
			<b-select
				name="options"
				v-model="selectedOption"
				:options="items"
				@change="value => this.$emit('onChange', value)"
			/>
		</div>
	</div>
</template>

<script>
import BSelect from '../components/Select.vue';

export default {
	components: {
		BSelect
	},
	data() {
		return {
			selectedOption: this.items[this.active]
		};
	},
	props: {
		/**
		 * Itens do menu.
		 **/
		items: {
			type: Array,
			default: () => []
		},
		/**
		 * Contadores (opcional; se inserido, deve ser do mesmo tamanho dos itens do menu).
		 **/
		counters: {
			type: Array,
			default: null
		},
		/**
		 * Item selecionado.
		 **/
		active: {
			type: String
		},
		/**
		 * Se true, o componente é renderizado na horizontal.
		 **/
		horizontal: {
			type: Boolean
		},
		/**
		 * Se true, o componente é renderizado na vertical.
		 **/
		vertical: {
			type: Boolean
		}
	}
};
</script>

<style lang="scss" scoped>
.border-horizontal {
	border-bottom: solid 1px #dcdbe1;
}

.border-vertical {
	border-left: solid 1px #dcdbe1;
}
.active-horizontal {
	border-bottom: solid 2px;
	transform: translate(-1.5px, 0);
}
.active-vertical {
	border-left: solid 2px;
	transform: translate(-1.5px, 0);
}
</style>
